import {Component, OnDestroy, OnInit, inject, HostListener} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/login/data-access/auth.service';
import {
  faBook,
  faBookOpen,
  faChevronDown, faChevronLeft,
  faClock,
  faFileAlt,
  faMagnifyingGlass
} from "@fortawesome/free-solid-svg-icons";
import {StudentExam} from "../../dashboard/feature/studentDashboard/studentDashboard.component";
import {Course} from "../../admin/data-access/course.model";
import {StatusFormatterPipe} from "../../dashboard/feature/studentDashboard/statusFormatter.pipe";
import {Pagination} from "../../exam/feature/exam-submissions/exam-submissions.component";
import {getDaysRemaining} from "../../shared/utils/getDaysRemaining";
import * as _ from "lodash";

enum AssessmentTabs {
  open,
  past,
  practice
}

export enum AssessmentTypes{
  all_types = 'All Types',
  exam = 'Exam',
  quiz = 'Quiz',
  homework = 'Homework',
}

@Component({
    selector: 'StudentClassroomAssessmentsComponent',
    templateUrl: './student-classroom-assessments.component.html',
    providers: [StatusFormatterPipe],
    styleUrls: ['./student-classroom-assessments.component.css'],
    standalone: false
})
export class StudentClassroomAssessmentsComponent implements OnInit, OnDestroy {
  assessmentTabStatus = AssessmentTabs.open;
  assessmentTypeSelected = AssessmentTypes.all_types;
  showAssessmentTypeDropdown = false
  authService = inject(AuthService);
  orgID: number[] = []
  examListResponse: StudentExam[] = []
  assessments: StudentExam[] = []
  optionalListResponse: Course[] = []
  isLoading: boolean = true
  isLoadingList: boolean = true
  isLoadingListOptional: boolean = true
  searchText: string = ''
  showPerPageDropdown = false
  currentPagination: Pagination = {
    limit: 15,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }

  userPerms: Subscription = this.authService.userDashboard$.subscribe((user) => {

    // TODO will need to change the get my exams to the classroom version
    if(user.success) {
      for(let perm of user.result) {
        // TODO push in a array to handle multiple orgs
        if(perm.organization_id != null && !this.orgID.includes(perm.organization_id) && perm.ui === 'ExamTake')
          this.orgID.push(perm.organization_id)
      }
      if(this.orgID.length > 0) {
        for(let org of this.orgID) {
          this.authService.getMyExams(org).subscribe((response) => {
            if(response.success) {
              this.examListResponse = this.examListResponse.concat(response.result)
            } else {
              // TODO handle error
            }
          })
          this.authService.getOptionalExams(org).subscribe((response) => {
            if(response.success) {
              this.optionalListResponse = response.result
            } else {
              // TODO handle error
            }
          })
        }
      }
    }
    this.isLoadingList = false
    this.isLoadingListOptional = false
  })

  ngOnDestroy() {}

  ngOnInit() {
    this.handleAssessmentAPI()
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if(urlParams.get('search') != null) {
      this.searchText = urlParams.get('search') as string;
    }
    if(urlParams.get('type') === 'exam') {
      // TODO filter based on type here
      this.assessmentTypeSelected = AssessmentTypes.exam;
    }
    if(urlParams.get('tab_status') === 'open') {
      this.assessmentTabStatus = AssessmentTabs.open;
    } else if(urlParams.get('tab_status') === 'past') {
      this.assessmentTabStatus = AssessmentTabs.past;
    }
  }

  handleAssessmentAPI() {
    this.authService.getMyClassroomAssessments(this.currentPagination.page,
      this.currentPagination.limit,
      this.searchText,
      true,
      true,
      true,
      this.assessmentTabStatus === AssessmentTabs.open,
      this.assessmentTabStatus === AssessmentTabs.past,
      this.assessmentTypeSelected,
    ).subscribe((response) => {
      if(response.success) {
        this.assessments = response.result;
        this.currentPagination.size = response.result.length;
        this.currentPagination.totalcount = response.total;
      }
    })
  }

  debounceSearch = _.debounce(() => {
    this.handleAssessmentAPI()
  }, 500)

  changeToPastTab() {
    this.assessmentTabStatus = AssessmentTabs.past
    this.currentPagination = {
      limit: 15,
      size: 0,
      page: 0,
      start: 0,
      totalcount: 0,
      maxpage: 0
    }
    this.handleAssessmentAPI()
  }

  changeToOpenTab() {
    this.assessmentTabStatus = AssessmentTabs.open
    this.currentPagination = {
      limit: 15,
      size: 0,
      page: 0,
      start: 0,
      totalcount: 0,
      maxpage: 0
    }
    this.handleAssessmentAPI()
  }

  switchAssessmentTypeSelected(type: AssessmentTypes) {
    this.assessmentTypeSelected = type;
    this.handleAssessmentAPI()
    this.showAssessmentTypeDropdown = false
  }

  changePaginationLimit(limit: number) {
    // TODO call the pagination service
    this.currentPagination.limit = limit;
    this.showPerPageDropdown = false
  }

  changePage(page: number) {
    // TODO call the pagination service
    if(page <= Math.ceil(this.examListResponse.length / this.currentPagination.limit) && page > 0)
      this.currentPagination.page = page
  }

  protected readonly faBookOpen = faBookOpen;
  protected readonly faFileAlt = faFileAlt;
  protected readonly faClock = faClock;
  AssessmentTabs = AssessmentTabs;
  AssessmentTypes = AssessmentTypes;
  protected readonly faBook = faBook;
  protected readonly faChevronDown = faChevronDown;
  protected readonly faMagnifyingGlass = faMagnifyingGlass;
  protected readonly faChevronLeft = faChevronLeft;
  protected readonly Math = Math;
  protected readonly getDaysRemaining = getDaysRemaining;
}
